import UploadForm from './upload-form'
export default UploadForm
